/**
 * corporateGifting.js
 *
 * @version 1.0.0
 */

(function () {

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', start, { once: true });
	} else {
		start();
	}

	function start() {
		if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
			return;
		}
		if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
			return;
		}

		gsap.registerPlugin(ScrollTrigger);
		buildReveals();
	}

	function buildReveals() {

		// A Tradition Worth Gifting.
		gsap.from('.cg-intro__container > *', {
			opacity: 0,
			y: 15,
			duration: 0.68,
			stagger: 0.056,
			ease: 'power2.out',
			clearProps: 'all',
			scrollTrigger: {
				trigger: '.cg-intro__container',
				start: 'top 88%',
				once: true,
			},
		});

		// Christmas releases.
		gsap.from('.cg-releases__text > *', {
			opacity: 0,
			x: -28,
			duration: 0.68,
			stagger: 0.056,
			ease: 'power2.out',
			clearProps: 'all',
			scrollTrigger: {
				trigger: '.cg-releases__text',
				start: 'top 88%',
				once: true,
			},
		});

		gsap.from('.cg-releases__img', {
			opacity: 0,
			scale: 1.06,
			duration: 0.88,
			ease: 'power2.out',
			clearProps: 'all',
			scrollTrigger: {
				trigger: '.cg-releases__media',
				start: 'top 88%',
				once: true,
			},
		});

		gsap.fromTo('.cg-products__img', {
			opacity: 0,
			clipPath: 'inset(100% 0% 0% 0%)',
			scale: 1.06,
		}, {
			opacity: 1,
			clipPath: 'inset(0% 0% 0% 0%)',
			scale: 1,
			duration: 0.88,
			stagger: 0.063,
			ease: 'power3.inOut',
			clearProps: 'all',
			scrollTrigger: {
				trigger: '.cg-products__grid',
				start: 'top 88%',
				once: true,
			},
		});

		// Gift Solutions.
		gsap.from('.cg-solutions__container > *', {
			opacity: 0,
			y: 15,
			duration: 0.68,
			stagger: 0.056,
			ease: 'power2.out',
			clearProps: 'all',
			scrollTrigger: {
				trigger: '.cg-solutions__container',
				start: 'top 88%',
				once: true,
			},
		});

		// Our Signature Gift Box.
		const signature = gsap.timeline({
			scrollTrigger: {
				trigger: '.cg-signature .cg-card',
				start: 'top 88%',
				once: true,
			},
		});

		signature.from('.cg-signature .cg-card', {
			opacity: 0,
			y: 17,
			duration: 0.82,
			ease: 'power2.out',
			clearProps: 'all',
		}, 0);

		gsap.from('.cg-signature__media', {
			opacity: 0,
			scale: 1.06,
			duration: 0.88,
			ease: 'power2.out',
			clearProps: 'all',
			scrollTrigger: {
				trigger: '.cg-signature__media',
				start: 'top 88%',
				once: true,
			},
		});

		signature.from('.cg-signature__text > *', {
			opacity: 0,
			y: 13,
			duration: 0.54,
			stagger: 0.056,
			ease: 'power2.out',
			clearProps: 'all',
		}, 0.14);

		// Build Your Own Gift.
		const build = gsap.timeline({
			scrollTrigger: {
				trigger: '.cg-build .cg-card',
				start: 'top 88%',
				once: true,
			},
		});

		build.from('.cg-build .cg-card', {
			opacity: 0,
			y: 17,
			duration: 0.82,
			ease: 'power2.out',
			clearProps: 'all',
		}, 0);

		build.from('.cg-build__text > *', {
			opacity: 0,
			y: 13,
			duration: 0.54,
			stagger: 0.056,
			ease: 'power2.out',
			clearProps: 'all',
		}, 0.14);

		gsap.from('.cg-build__options', {
			opacity: 0,
			scale: 1.06,
			duration: 0.88,
			ease: 'power2.out',
			clearProps: 'all',
			scrollTrigger: {
				trigger: '.cg-build__options',
				start: 'top 88%',
				once: true,
			},
		});

		// How It Works.
		gsap.from('.cg-process__eyebrow, .cg-process__heading', {
			opacity: 0,
			y: 15,
			duration: 0.68,
			stagger: 0.056,
			ease: 'power2.out',
			clearProps: 'all',
			scrollTrigger: {
				trigger: '.cg-process__container',
				start: 'top 88%',
				once: true,
			},
		});

		const steps = gsap.timeline({
			scrollTrigger: {
				trigger: '.cg-process__steps',
				start: 'top 88%',
				once: true,
			},
		});

		steps.from('.cg-process__step', {
			opacity: 0,
			y: 20,
			scale: 0.98,
			duration: 0.82,
			stagger: 0.084,
			ease: 'power2.out',
			clearProps: 'all',
		}, 0);

		steps.from('.cg-process__icon', {
			opacity: 0,
			scale: 0.72,
			duration: 0.68,
			stagger: 0.084,
			ease: 'back.out(1.2)',
			clearProps: 'all',
		}, 0.14);

		gsap.from('.cg-process__actions', {
			opacity: 0,
			y: 17,
			duration: 0.68,
			ease: 'power2.out',
			clearProps: 'all',
			scrollTrigger: {
				trigger: '.cg-process__actions',
				start: 'top 88%',
				once: true,
			},
		});

		// Handmade in Beechworth.
		gsap.from('.cg-story__img', {
			opacity: 0,
			scale: 1.06,
			duration: 0.88,
			ease: 'power2.out',
			clearProps: 'all',
			scrollTrigger: {
				trigger: '.cg-story__media',
				start: 'top 88%',
				once: true,
			},
		});

		const story = gsap.timeline({
			scrollTrigger: {
				trigger: '.cg-story__panel',
				start: 'top 88%',
				once: true,
			},
		});

		story.from('.cg-story__panel', {
			opacity: 0,
			y: 17,
			duration: 0.82,
			ease: 'power2.out',
			clearProps: 'all',
		}, 0);

		story.from('.cg-story__panel > *', {
			opacity: 0,
			y: 13,
			duration: 0.54,
			stagger: 0.056,
			ease: 'power2.out',
			clearProps: 'all',
		}, 0.14);

		// Questions.
		gsap.from('.cg-faq__intro > *', {
			opacity: 0,
			x: -28,
			duration: 0.68,
			stagger: 0.056,
			ease: 'power2.out',
			clearProps: 'all',
			scrollTrigger: {
				trigger: '.cg-faq__intro',
				start: 'top 88%',
				once: true,
			},
		});

		gsap.from('.cg-faq__item, .cg-faq__outro', {
			opacity: 0,
			y: 13,
			duration: 0.54,
			stagger: 0.056,
			ease: 'power2.out',
			clearProps: 'all',
			scrollTrigger: {
				trigger: '.cg-faq__questions',
				start: 'top 88%',
				once: true,
			},
		});

		// Testimonials.
		gsap.from('.cg-quote__figure > *', {
			opacity: 0,
			y: 15,
			duration: 0.68,
			stagger: 0.056,
			ease: 'power2.out',
			clearProps: 'all',
			scrollTrigger: {
				trigger: '.cg-quote__figure',
				start: 'top 88%',
				once: true,
			},
		});

		// Get In Touch.
		gsap.from('.cg-enquiry__intro > *', {
			opacity: 0,
			x: -28,
			duration: 0.68,
			stagger: 0.056,
			ease: 'power2.out',
			clearProps: 'all',
			scrollTrigger: {
				trigger: '.cg-enquiry__intro',
				start: 'top 88%',
				once: true,
			},
		});

		gsap.from('.cg-form__field, .cg-form__actions', {
			opacity: 0,
			y: 13,
			duration: 0.54,
			stagger: 0.056,
			ease: 'power2.out',
			clearProps: 'all',
			scrollTrigger: {
				trigger: '.cg-enquiry__form',
				start: 'top 88%',
				once: true,
			},
		});

		// End-of-year functions.
		gsap.from('.cg-events__content > *', {
			opacity: 0,
			x: -28,
			duration: 0.68,
			stagger: 0.056,
			ease: 'power2.out',
			clearProps: 'all',
			scrollTrigger: {
				trigger: '.cg-events__content',
				start: 'top 88%',
				once: true,
			},
		});

		gsap.from('.cg-events__img', {
			opacity: 0,
			scale: 1.06,
			duration: 0.88,
			ease: 'power2.out',
			clearProps: 'all',
			scrollTrigger: {
				trigger: '.cg-events__media',
				start: 'top 88%',
				once: true,
			},
		});
	}
})();
